import React from 'react';

import cn from 'classnames';

import { Input } from '@shared/ui';

import cls from './PeriodPickerItem.module.css';
import { useChangePeriodDate, usePeriodPickerItem } from '../../../lib/hooks';
import { IPeriodPickerItemProps } from '../../../model/types';

export const PeriodPickerItem = ({
    itemType,
    itemData,
    isPicked,
    onClickHandler,
    periodValue,
    onChangePeriod,
    onChangeRangeQueryValues,
}: IPeriodPickerItemProps & {
    periodValue?: string;
    onChangePeriod?: (v: string) => void;
    onChangeRangeQueryValues?: (raw?: string) => void;
}) => {
    const { inputEnable, inputRef, onPickerClick, disableInput } = usePeriodPickerItem({
        itemType,
        itemData,
        isPicked,
        onClickHandler,
    });

    const { handleChange } = useChangePeriodDate({
        value: periodValue,
        setValue: onChangePeriod,
    });

    return (
        <li
            key={itemData.id}
            className={cn(cls.PeriodListItem, isPicked && cls.isPicked)}
            onClick={onPickerClick}
        >
            {itemType === 'input' && (inputEnable || isPicked) && (
                <Input
                    ref={inputRef}
                    className={cn(
                        cls.ChoosePeriodInput,
                        itemType === 'input' && isPicked && cls.isPicked
                    )}
                    onChange={handleChange}
                    value={periodValue}
                    onBlur={(e) => {
                        if (!periodValue.length) {
                            disableInput();
                            return;
                        }
                        const next = e.relatedTarget as HTMLElement | null;
                        const goingToCalendar =
                            next?.closest?.('.react-datepicker') ||
                            document.activeElement?.closest?.('.react-datepicker');

                        if (goingToCalendar) {
                            return;
                        }

                        onChangeRangeQueryValues?.(periodValue);
                        disableInput();
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            onChangeRangeQueryValues?.(periodValue);
                            disableInput();
                        }
                    }}
                />
            )}
            {itemType === 'button' && <span>{itemData.title}</span>}
            {!inputEnable && itemType === 'input' && !isPicked && <span>{itemData.title}</span>}
        </li>
    );
};
